import { IDMEUSERDATA_LOADING, GET_IDMEUSERDATA_DATA_SUCCESS, GET_IDMEUSERDATA_DATA_ERROR } from "../actions/actionIDMeUserData";
import { put, takeEvery } from 'redux-saga/effects';
import { apiIDMeUserData } from 'api';

async function fetchAsync(func, param) {
    const response = await func(param);

    if (response.ok && response.status == 200) {
        return await response.json();
    }
    else if (response.status == 204) {
        return "nocontent";
    }
    if (response.status == 400) {
        let error = await response.json();
        throw JSON.parse("{\"Errors\":[{\"ErrorMessage\":\"" + error.Errors[0].ErrorMessage.replace('Error: ', '') + " response status: " + response.status + "\"}]}")
    }
    else {
        throw JSON.parse("{\"Errors\":[{\"ErrorMessage\":\"Unable to get ID.Me User Data, response status: " + response.status + "\"}]}")
    }
}

function* fetchIDMEUserData(action) {
    try {
        const data = yield fetchAsync(apiIDMeUserData, action.payload)
        yield put({ type: GET_IDMEUSERDATA_DATA_SUCCESS, payload: data });
    } catch (e) {
        yield put({ type: GET_IDMEUSERDATA_DATA_ERROR, error: e }); //.Errors[0].ErrorMessage
    }
}

export const sagaIdMeUserData = [
    takeEvery(IDMEUSERDATA_LOADING, fetchIDMEUserData)
];
